import React from 'react';
import { cn } from '../../utils/cn';
interface LogoProps {
  className?: string;
  variant?: 'light' | 'dark';
}
export function Logo({
  className
}: LogoProps) {
  // Logo always rendered in white per brand request
  const color = '#FFFFFF';
  return <div className={cn('flex items-center gap-3', className)} role="img" aria-label="ANETO — Donde vivir" data-id="element-346" data-mp="ru9ya6ankt5f">
      <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0" data-id="element-347" data-mp="iv53nb27pjyj">
        {/* Main peak */}
        <path d="M24 6L6 42H42L24 6Z" stroke={color} strokeWidth="2" strokeLinejoin="round" data-id="element-348" data-mp="8wpa71fppylv" />
        {/* Secondary peak */}
        <path d="M32 22L22 42H42L32 22Z" stroke={color} strokeWidth="2" strokeLinejoin="round" data-id="element-349" data-mp="4y01vn9j7793" />
      </svg>

      {/* Divider */}
      <span aria-hidden="true" className="block w-px h-9 bg-white/70" data-id="element-350" data-mp="1zag1i57tnn4z" />

      {/* Wordmark */}
      <div className="flex flex-col leading-none" data-id="element-351" data-mp="1e6ejkwiulss0">
        <span className="font-serif text-2xl md:text-3xl font-bold tracking-[0.35em] text-white drop-shadow-sm" data-id="element-352" data-mp="1j7c3penf4ww5">
          ANETO
        </span>
        <span className="text-[0.55rem] md:text-[0.6rem] tracking-[0.45em] text-white/80 mt-1.5 self-end" data-id="element-353" data-mp="158uhjld5vsgc">
          DONDE VIVIR
        </span>
      </div>
    </div>;
}